//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.0.0 (NJsonSchema v10.7.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllAddresses(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AddressSearchResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/address";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllAddresses(_response);
        });
    }

    protected processGetAllAddresses(response: Response): Promise<AddressSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddressSearchResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createAddress(v: string, agentId: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateAddressModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/address";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAddress(_response);
        });
    }

    protected processCreateAddress(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateAddress(v: string, agentId: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateAddressModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/address";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAddress(_response);
        });
    }

    protected processUpdateAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAddressById(id: number, agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AddressModel> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/address/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAddressById(_response);
        });
    }

    protected processGetAddressById(response: Response): Promise<AddressModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddressModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddressModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteAddress(agentId: number, id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/address/{id}";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAddress(_response);
        });
    }

    protected processDeleteAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAddressTypeLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/addressTypeLookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAddressTypeLookup(_response);
        });
    }

    protected processGetAddressTypeLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    makeDefaultAddress(agentId: number, id: number, addressType: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/address/{id}/default/{addressType}";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (addressType === undefined || addressType === null)
            throw new Error("The parameter 'addressType' must be defined.");
        url_ = url_.replace("{addressType}", encodeURIComponent("" + addressType));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMakeDefaultAddress(_response);
        });
    }

    protected processMakeDefaultAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentByIdForUpdate(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<UpdateAgentModel> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentByIdForUpdate(_response);
        });
    }

    protected processGetAgentByIdForUpdate(response: Response): Promise<UpdateAgentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UpdateAgentModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentForCreate(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CreateAgentModel> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/add";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentForCreate(_response);
        });
    }

    protected processGetAgentForCreate(response: Response): Promise<CreateAgentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAgentModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAgentModel>(null as any);
    }

    /**
     * @param email (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getMarketingPreferencesByEmail(v: string, email?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<MarketingPreferencesResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/marketingpreferences?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (email !== undefined && email !== null)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMarketingPreferencesByEmail(_response);
        });
    }

    protected processGetMarketingPreferencesByEmail(response: Response): Promise<MarketingPreferencesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketingPreferencesResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingPreferencesResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getEmailByAgentId(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/email";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmailByAgentId(_response);
        });
    }

    protected processGetEmailByAgentId(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getSummaryById(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentSummaryModel> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/summary";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSummaryById(_response);
        });
    }

    protected processGetSummaryById(response: Response): Promise<AgentSummaryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentSummaryModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    agentMarketersById(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentMarketersModel> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/marketers";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAgentMarketersById(_response);
        });
    }

    protected processAgentMarketersById(response: Response): Promise<AgentMarketersModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentMarketersModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentHierarchy(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentSummaryHierarchyResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/agenthierarchy";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentHierarchy(_response);
        });
    }

    protected processGetAgentHierarchy(response: Response): Promise<AgentSummaryHierarchyResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentSummaryHierarchyResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentProfileInfoById(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentProfileInfoModel> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/profileinfo";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentProfileInfoById(_response);
        });
    }

    protected processGetAgentProfileInfoById(response: Response): Promise<AgentProfileInfoModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentProfileInfoModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgencyByAgentId(agentId: number, v: string, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgencySearchResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/agencies?";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgencyByAgentId(_response);
        });
    }

    protected processGetAgencyByAgentId(response: Response): Promise<AgencySearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgencySearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgencySearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    downloadProfilePic(agentid: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DownloadProfilePicModel> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentid}/downloadprofile";
        if (agentid === undefined || agentid === null)
            throw new Error("The parameter 'agentid' must be defined.");
        url_ = url_.replace("{agentid}", encodeURIComponent("" + agentid));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadProfilePic(_response);
        });
    }

    protected processDownloadProfilePic(response: Response): Promise<DownloadProfilePicModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadProfilePicModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadProfilePicModel>(null as any);
    }

    /**
     * @param sSN (optional) 
     * @param encryptedSSN (optional) 
     * @param nPN (optional) 
     * @param agentId (optional) 
     * @param isAgency (optional) 
     * @param tIN (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    checkAgentDuplicate(firstName: string, lastName: string, v: string, sSN?: string | null | undefined, encryptedSSN?: string | null | undefined, nPN?: string | null | undefined, agentId?: number | undefined, isAgency?: boolean | undefined, tIN?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/agent/checkagentduplicate?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (firstName === undefined || firstName === null)
            throw new Error("The parameter 'firstName' must be defined and cannot be null.");
        else
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName === undefined || lastName === null)
            throw new Error("The parameter 'lastName' must be defined and cannot be null.");
        else
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (sSN !== undefined && sSN !== null)
            url_ += "SSN=" + encodeURIComponent("" + sSN) + "&";
        if (encryptedSSN !== undefined && encryptedSSN !== null)
            url_ += "EncryptedSSN=" + encodeURIComponent("" + encryptedSSN) + "&";
        if (nPN !== undefined && nPN !== null)
            url_ += "NPN=" + encodeURIComponent("" + nPN) + "&";
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (isAgency === null)
            throw new Error("The parameter 'isAgency' cannot be null.");
        else if (isAgency !== undefined)
            url_ += "IsAgency=" + encodeURIComponent("" + isAgency) + "&";
        if (tIN !== undefined && tIN !== null)
            url_ += "TIN=" + encodeURIComponent("" + tIN) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckAgentDuplicate(_response);
        });
    }

    protected processCheckAgentDuplicate(response: Response): Promise<AgentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentLeadSourceLookup(fromList: boolean, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{fromList}/leadsourcelookup";
        if (fromList === undefined || fromList === null)
            throw new Error("The parameter 'fromList' must be defined.");
        url_ = url_.replace("{fromList}", encodeURIComponent("" + fromList));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentLeadSourceLookup(_response);
        });
    }

    protected processGetAgentLeadSourceLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentLeadPhaseLookup(leadphaseid: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{leadphaseid}/leadphaselookup";
        if (leadphaseid === undefined || leadphaseid === null)
            throw new Error("The parameter 'leadphaseid' must be defined.");
        url_ = url_.replace("{leadphaseid}", encodeURIComponent("" + leadphaseid));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentLeadPhaseLookup(_response);
        });
    }

    protected processGetAgentLeadPhaseLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentLeadPhaseDetailsLookup(leadphaseid: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{leadphaseid}/leadphaseDetailslookup";
        if (leadphaseid === undefined || leadphaseid === null)
            throw new Error("The parameter 'leadphaseid' must be defined.");
        url_ = url_.replace("{leadphaseid}", encodeURIComponent("" + leadphaseid));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentLeadPhaseDetailsLookup(_response);
        });
    }

    protected processGetAgentLeadPhaseDetailsLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getReportAgentStatusLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/reportagentstatuslookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReportAgentStatusLookup(_response);
        });
    }

    protected processGetReportAgentStatusLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentMarketersLookup(v: string, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentMarketerSearchResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/agentmarketerslookup?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentMarketersLookup(_response);
        });
    }

    protected processGetAgentMarketersLookup(response: Response): Promise<AgentMarketerSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentMarketerSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentMarketerSearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentStatusById(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentStatusByIdResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/agentcurrentstatus";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentStatusById(_response);
        });
    }

    protected processGetAgentStatusById(response: Response): Promise<AgentStatusByIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentStatusByIdResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    checkDNXOption(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{id}/checkDNxoption";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckDNXOption(_response);
        });
    }

    protected processCheckDNXOption(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentCurrentTime(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentCurrentTimeResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/agentcurrenttime";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentCurrentTime(_response);
        });
    }

    protected processGetAgentCurrentTime(response: Response): Promise<AgentCurrentTimeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentCurrentTimeResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgencyReference(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/agencyreference";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgencyReference(_response);
        });
    }

    protected processGetAgencyReference(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param recuriterId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentIdByRecuriter(v: string, recuriterId?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/GetAgentIdByRecuriter?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (recuriterId !== undefined && recuriterId !== null)
            url_ += "RecuriterId=" + encodeURIComponent("" + recuriterId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentIdByRecuriter(_response);
        });
    }

    protected processGetAgentIdByRecuriter(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param fromList (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentMarketerClassificationLookup(v: string, fromList?: boolean | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/agentMarketerClassificationLookup?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (fromList === null)
            throw new Error("The parameter 'fromList' cannot be null.");
        else if (fromList !== undefined)
            url_ += "fromList=" + encodeURIComponent("" + fromList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentMarketerClassificationLookup(_response);
        });
    }

    protected processGetAgentMarketerClassificationLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param searchType (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentImmediateUpline(v: string, searchType?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentImmediateUplineResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/agentimmediateupline?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (searchType === null)
            throw new Error("The parameter 'searchType' cannot be null.");
        else if (searchType !== undefined)
            url_ += "SearchType=" + encodeURIComponent("" + searchType) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentImmediateUpline(_response);
        });
    }

    protected processGetAgentImmediateUpline(response: Response): Promise<AgentImmediateUplineResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentImmediateUplineResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentImmediateUplineResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    agentHierarchyLevelLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/hierarchylevelLookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAgentHierarchyLevelLookup(_response);
        });
    }

    protected processAgentHierarchyLevelLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    agentHierarchyDetailsById(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentHierarchyDetailsResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/agenthierarchydetailsbyid";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAgentHierarchyDetailsById(_response);
        });
    }

    protected processAgentHierarchyDetailsById(response: Response): Promise<AgentHierarchyDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentHierarchyDetailsResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentReportingHierarchy(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentHierarchyResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/agentreporthierarchy";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentReportingHierarchy(_response);
        });
    }

    protected processGetAgentReportingHierarchy(response: Response): Promise<AgentHierarchyResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentHierarchyResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param agentId (optional) 
     * @param searchText (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    downloadAgentReportingHierarchy(v: string, agentId?: number | undefined, searchText?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/downloadagentreporthierarchy?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadAgentReportingHierarchy(_response);
        });
    }

    protected processDownloadAgentReportingHierarchy(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentW9Information(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentHierarchyResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/agentw9information";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentW9Information(_response);
        });
    }

    protected processGetAgentW9Information(response: Response): Promise<AgentHierarchyResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentHierarchyResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createAgent(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateAgentModel | undefined): Promise<AgentResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/createAgent";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAgent(_response);
        });
    }

    protected processCreateAgent(response: Response): Promise<AgentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentResponse;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateAgent(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: UpdateAgentModel | undefined): Promise<AgentResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/updateAgent";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAgent(_response);
        });
    }

    protected processUpdateAgent(response: Response): Promise<AgentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    mergeAgentPreview(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: MergeAgentPreviewRequestModel | undefined): Promise<MergeAgentPreviewResponseModel> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/mergeagentpreview";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMergeAgentPreview(_response);
        });
    }

    protected processMergeAgentPreview(response: Response): Promise<MergeAgentPreviewResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MergeAgentPreviewResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MergeAgentPreviewResponseModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    saveAgentMarketer(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: SaveAgentMarketerRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/saveagentmarketer";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveAgentMarketer(_response);
        });
    }

    protected processSaveAgentMarketer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createConnectAgent(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateConnectAgentWithContactsModel | undefined): Promise<AgentResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/CreateConnectAgent";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateConnectAgent(_response);
        });
    }

    protected processCreateConnectAgent(response: Response): Promise<AgentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentResponse;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createUserAgent(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateConnectAgentModel | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/CreateUserAgent";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateUserAgent(_response);
        });
    }

    protected processCreateUserAgent(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    sendSupplierFile(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<Date> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/sendsupplierfile";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendSupplierFile(_response);
        });
    }

    protected processSendSupplierFile(response: Response): Promise<Date> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? (resultData200 !== null ? new Date(resultData200.toString()) : <any>null) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Date>(null as any);
    }

    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getLatestSupplierFileLog(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<Date | null> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/latestsupplierfilelog";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLatestSupplierFileLog(_response);
        });
    }

    protected processGetLatestSupplierFileLog(response: Response): Promise<Date | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? (resultData200 !== null ? new Date(resultData200.toString()) : <any>null) : <any>null;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Date | null>(null);
    }

    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateProfileLoginByAgentId(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: AgentProfileLoginModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/profilelogin";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateProfileLoginByAgentId(_response);
        });
    }

    protected processUpdateProfileLoginByAgentId(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateReceivePaperStatementByAgentId(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: AgentReceivePaperStatementModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/receivepaperstatement";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateReceivePaperStatementByAgentId(_response);
        });
    }

    protected processUpdateReceivePaperStatementByAgentId(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional)
     * @return Success
     */
    updateAgentLegalEntityStatus(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: AgentLegalEntityStatusModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/legalentitystatus";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAgentLegalEntityStatus(_response);
        });
    }

    protected processUpdateAgentLegalEntityStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateMarketingPreferencesByEmail(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: MarketingPreferencesModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/managemarketingpreferences";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMarketingPreferencesByEmail(_response);
        });
    }

    protected processUpdateMarketingPreferencesByEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    _UploadProfilePic(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: UploadProfilePicModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/uploadprofile";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.process_UploadProfilePic(_response);
        });
    }

    protected process_UploadProfilePic(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    mergeAgent(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: MergeAgentPreviewRequestModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/mergeagent";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMergeAgent(_response);
        });
    }

    protected processMergeAgent(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateAgentW9Information(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: UpdateAgentW9InformationRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/updateagentw9";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAgentW9Information(_response);
        });
    }

    protected processUpdateAgentW9Information(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param agentId (optional) 
     * @param parentId (optional) 
     * @param selfUpline (optional) 
     * @param hierarchyLevelId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    updateAgentImmediateUpline(v: string, agentId?: number | undefined, parentId?: number | undefined, selfUpline?: boolean | undefined, hierarchyLevelId?: number | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/updateagentimmediateupline?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (parentId === null)
            throw new Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "ParentId=" + encodeURIComponent("" + parentId) + "&";
        if (selfUpline === null)
            throw new Error("The parameter 'selfUpline' cannot be null.");
        else if (selfUpline !== undefined)
            url_ += "SelfUpline=" + encodeURIComponent("" + selfUpline) + "&";
        if (hierarchyLevelId !== undefined && hierarchyLevelId !== null)
            url_ += "HierarchyLevelId=" + encodeURIComponent("" + hierarchyLevelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAgentImmediateUpline(_response);
        });
    }

    protected processUpdateAgentImmediateUpline(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAlertByAgentId(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AlertByAgentIdResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/alert";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAlertByAgentId(_response);
        });
    }

    protected processGetAlertByAgentId(response: Response): Promise<AlertByAgentIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AlertByAgentIdResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertByAgentIdResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteAlert(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/alert";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAlert(_response);
        });
    }

    protected processDeleteAlert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createAlert(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateAlertRequestModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/createAlert";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAlert(_response);
        });
    }

    protected processCreateAlert(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateAlert(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateAlertRequestModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/updateAlert";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAlert(_response);
        });
    }

    protected processUpdateAlert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param agentId (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllContact(v: string, agentId?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ContactByAgentIdResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/contacts?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllContact(_response);
        });
    }

    protected processGetAllContact(response: Response): Promise<ContactByAgentIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactByAgentIdResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactByAgentIdResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContactTypes(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/contacttypes";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContactTypes(_response);
        });
    }

    protected processGetContactTypes(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPhoneTypes(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/phonetypes";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPhoneTypes(_response);
        });
    }

    protected processGetPhoneTypes(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getEmailType(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/emailtype";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmailType(_response);
        });
    }

    protected processGetEmailType(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAlternativePOCType(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/alternativePOCtype";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAlternativePOCType(_response);
        });
    }

    protected processGetAlternativePOCType(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContactById(id: number, v: string, agentId: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ContactByIdModel> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/contacts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContactById(_response);
        });
    }

    protected processGetContactById(response: Response): Promise<ContactByIdModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactByIdModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteContact(id: number, v: string, agentId: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/contacts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteContact(_response);
        });
    }

    protected processDeleteContact(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param agentId (optional) 
     * @param contactId (optional) 
     * @param noOfMessages (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContactSMSBody(v: string, agentId?: number | undefined, contactId?: number | undefined, noOfMessages?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ContactSMSBodyResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/getcontactsmsbody?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "ContactId=" + encodeURIComponent("" + contactId) + "&";
        if (noOfMessages === null)
            throw new Error("The parameter 'noOfMessages' cannot be null.");
        else if (noOfMessages !== undefined)
            url_ += "NoOfMessages=" + encodeURIComponent("" + noOfMessages) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContactSMSBody(_response);
        });
    }

    protected processGetContactSMSBody(response: Response): Promise<ContactSMSBodyResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactSMSBodyResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactSMSBodyResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContactSMS(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/contactsms";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContactSMS(_response);
        });
    }

    protected processGetContactSMS(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param agentId (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllPhonePreferences(v: string, agentId?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PhonePreferenceByAgentIdResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/phonepreferences?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "agentId=" + encodeURIComponent("" + agentId) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPhonePreferences(_response);
        });
    }

    protected processGetAllPhonePreferences(response: Response): Promise<PhonePreferenceByAgentIdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PhonePreferenceByAgentIdResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PhonePreferenceByAgentIdResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    createDNxNote(agentId: number, isDNxOverride: boolean, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/DNxNote/{isDNxOverride}";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (isDNxOverride === undefined || isDNxOverride === null)
            throw new Error("The parameter 'isDNxOverride' must be defined.");
        url_ = url_.replace("{isDNxOverride}", encodeURIComponent("" + isDNxOverride));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateDNxNote(_response);
        });
    }

    protected processCreateDNxNote(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createContact(v: string, agentId: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateContactModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/contacts";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateContact(_response);
        });
    }

    protected processCreateContact(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateContact(v: string, agentId: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateUpdateContactModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/contacts";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateContact(_response);
        });
    }

    protected processUpdateContact(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    sendSms(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: SendTextMessageRequest | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/sendsms";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendSms(_response);
        });
    }

    protected processSendSms(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param notDefault (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    makeDefault(agentId: number, id: number, contacttypeid: number, v: string, notDefault?: boolean | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/contacts/{id}/contacttype/{contacttypeid}/default?";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (contacttypeid === undefined || contacttypeid === null)
            throw new Error("The parameter 'contacttypeid' must be defined.");
        url_ = url_.replace("{contacttypeid}", encodeURIComponent("" + contacttypeid));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (notDefault === null)
            throw new Error("The parameter 'notDefault' cannot be null.");
        else if (notDefault !== undefined)
            url_ += "notDefault=" + encodeURIComponent("" + notDefault) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMakeDefault(_response);
        });
    }

    protected processMakeDefault(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    setAsCommission(agentId: number, id: number, contacttypeid: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/contacts/{id}/contacttype/{contacttypeid}/setascommission";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (contacttypeid === undefined || contacttypeid === null)
            throw new Error("The parameter 'contacttypeid' must be defined.");
        url_ = url_.replace("{contacttypeid}", encodeURIComponent("" + contacttypeid));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetAsCommission(_response);
        });
    }

    protected processSetAsCommission(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    setEnableSMS(id: number, enableSMS: boolean, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{id}/contacts/{enableSMS}/setenablesms";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (enableSMS === undefined || enableSMS === null)
            throw new Error("The parameter 'enableSMS' must be defined.");
        url_ = url_.replace("{enableSMS}", encodeURIComponent("" + enableSMS));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetEnableSMS(_response);
        });
    }

    protected processSetEnableSMS(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    setIsMessageRead(messageId: number, ismessageread: boolean, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{messageId}/contacts/{ismessageread}/setismessageread";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        if (ismessageread === undefined || ismessageread === null)
            throw new Error("The parameter 'ismessageread' must be defined.");
        url_ = url_.replace("{ismessageread}", encodeURIComponent("" + ismessageread));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetIsMessageRead(_response);
        });
    }

    protected processSetIsMessageRead(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updatePhonePreference(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: UpdatePhonePreferenceModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/updatephonepreference";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePhonePreference(_response);
        });
    }

    protected processUpdatePhonePreference(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContractApprovers(emailAddress: string | null, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ContractApproversResponse[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/contractApprovers/{emailAddress}";
        if (emailAddress === undefined || emailAddress === null)
            throw new Error("The parameter 'emailAddress' must be defined.");
        url_ = url_.replace("{emailAddress}", encodeURIComponent("" + emailAddress));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContractApprovers(_response);
        });
    }

    protected processGetContractApprovers(response: Response): Promise<ContractApproversResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContractApproversResponse[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContractApproversResponse[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getRecentAgentsByMarketerForDA(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentResponse2[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/recentagents";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRecentAgentsByMarketerForDA(_response);
        });
    }

    protected processGetRecentAgentsByMarketerForDA(response: Response): Promise<AgentResponse2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentResponse2[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentResponse2[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentByAgentIdForDA(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentResponse2> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/{agentId}";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentByAgentIdForDA(_response);
        });
    }

    protected processGetAgentByAgentIdForDA(response: Response): Promise<AgentResponse2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentResponse2;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param city (optional) 
     * @param state (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getTopAgentsByAgentNameForDA(agentName: string, v: string, city?: string | null | undefined, state?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentResponse2> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/agents?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentName === undefined || agentName === null)
            throw new Error("The parameter 'agentName' must be defined and cannot be null.");
        else
            url_ += "AgentName=" + encodeURIComponent("" + agentName) + "&";
        if (city !== undefined && city !== null)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTopAgentsByAgentNameForDA(_response);
        });
    }

    protected processGetTopAgentsByAgentNameForDA(response: Response): Promise<AgentResponse2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentResponse2;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentResponse2>(null as any);
    }

    /**
     * @param carrierId (optional) 
     * @param productTypeId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCommissionSummaryByAgentIdForDA(agentId: number, v: string, carrierId?: number | null | undefined, productTypeId?: number | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CommissionSummaryResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/commissionsummary?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined and cannot be null.");
        else
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (carrierId !== undefined && carrierId !== null)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (productTypeId !== undefined && productTypeId !== null)
            url_ += "ProductTypeId=" + encodeURIComponent("" + productTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommissionSummaryByAgentIdForDA(_response);
        });
    }

    protected processGetCommissionSummaryByAgentIdForDA(response: Response): Promise<CommissionSummaryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommissionSummaryResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommissionSummaryResponse>(null as any);
    }

    /**
     * @param carrierId (optional) 
     * @param requestFor (optional) 
     * @param productTypeId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCarriersByAgentIdForDA(agentId: number, v: string, carrierId?: number | null | undefined, requestFor?: string | null | undefined, productTypeId?: number | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CarrierResponse[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/carrier?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined and cannot be null.");
        else
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (carrierId !== undefined && carrierId !== null)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (requestFor !== undefined && requestFor !== null)
            url_ += "requestFor=" + encodeURIComponent("" + requestFor) + "&";
        if (productTypeId !== undefined && productTypeId !== null)
            url_ += "ProductTypeId=" + encodeURIComponent("" + productTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCarriersByAgentIdForDA(_response);
        });
    }

    protected processGetCarriersByAgentIdForDA(response: Response): Promise<CarrierResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CarrierResponse[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CarrierResponse[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllCarriersForDA(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CarrierResponse[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/allCarriers";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllCarriersForDA(_response);
        });
    }

    protected processGetAllCarriersForDA(response: Response): Promise<CarrierResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CarrierResponse[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CarrierResponse[]>(null as any);
    }

    /**
     * @param productTypeId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCommissionDetailsForDA(agentId: number, carrierId: number, v: string, productTypeId?: number | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<CommissionDetailResponse[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/commissiondetails?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined and cannot be null.");
        else
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (carrierId === undefined || carrierId === null)
            throw new Error("The parameter 'carrierId' must be defined and cannot be null.");
        else
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (productTypeId !== undefined && productTypeId !== null)
            url_ += "ProductTypeId=" + encodeURIComponent("" + productTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommissionDetailsForDA(_response);
        });
    }

    protected processGetCommissionDetailsForDA(response: Response): Promise<CommissionDetailResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommissionDetailResponse[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommissionDetailResponse[]>(null as any);
    }

    /**
     * @param contractId (optional) 
     * @param productTypeId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getProductTypesForAgentForDA(agentId: number, carrierId: number, v: string, contractId?: number | undefined, productTypeId?: number | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ProductTypeResponse[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/producttypes?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined and cannot be null.");
        else
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (carrierId === undefined || carrierId === null)
            throw new Error("The parameter 'carrierId' must be defined and cannot be null.");
        else
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "ContractId=" + encodeURIComponent("" + contractId) + "&";
        if (productTypeId !== undefined && productTypeId !== null)
            url_ += "ProductTypeId=" + encodeURIComponent("" + productTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductTypesForAgentForDA(_response);
        });
    }

    protected processGetProductTypesForAgentForDA(response: Response): Promise<ProductTypeResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductTypeResponse[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductTypeResponse[]>(null as any);
    }

    /**
     * @param productTypeId (optional) 
     * @param contractId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPayoutDetailsForDA(carrierId: number, agentId: number, v: string, productTypeId?: number | null | undefined, contractId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PayoutResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/payoutdetails?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (carrierId === undefined || carrierId === null)
            throw new Error("The parameter 'carrierId' must be defined and cannot be null.");
        else
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined and cannot be null.");
        else
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (productTypeId !== undefined && productTypeId !== null)
            url_ += "ProductTypeId=" + encodeURIComponent("" + productTypeId) + "&";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "ContractId=" + encodeURIComponent("" + contractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPayoutDetailsForDA(_response);
        });
    }

    protected processGetPayoutDetailsForDA(response: Response): Promise<PayoutResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayoutResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PayoutResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContractCountByAgentIdForDA(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/{agentId}/contractcount";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContractCountByAgentIdForDA(_response);
        });
    }

    protected processGetContractCountByAgentIdForDA(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param hierarchyType (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getHierarchyDetailsForDA(agentId: number, carrierId: number, contractId: number, v: string, hierarchyType?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentHierarchyResponse2> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/hierarchydetails?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined and cannot be null.");
        else
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (carrierId === undefined || carrierId === null)
            throw new Error("The parameter 'carrierId' must be defined and cannot be null.");
        else
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined and cannot be null.");
        else
            url_ += "ContractId=" + encodeURIComponent("" + contractId) + "&";
        if (hierarchyType !== undefined && hierarchyType !== null)
            url_ += "HierarchyType=" + encodeURIComponent("" + hierarchyType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHierarchyDetailsForDA(_response);
        });
    }

    protected processGetHierarchyDetailsForDA(response: Response): Promise<AgentHierarchyResponse2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentHierarchyResponse2;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentHierarchyResponse2>(null as any);
    }

    /**
     * @param addressType (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentAddressByAgentIdForDA(agentID: number, v: string, addressType?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentAddressResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/agentaddress?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentID === undefined || agentID === null)
            throw new Error("The parameter 'agentID' must be defined and cannot be null.");
        else
            url_ += "AgentID=" + encodeURIComponent("" + agentID) + "&";
        if (addressType !== undefined && addressType !== null)
            url_ += "addressType=" + encodeURIComponent("" + addressType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentAddressByAgentIdForDA(_response);
        });
    }

    protected processGetAgentAddressByAgentIdForDA(response: Response): Promise<AgentAddressResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentAddressResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentAddressResponse>(null as any);
    }

    /**
     * @param contactType (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContactInfoByAgentIdForDA(agentID: number, v: string, contactType?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentContactResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/agentContact?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentID === undefined || agentID === null)
            throw new Error("The parameter 'agentID' must be defined and cannot be null.");
        else
            url_ += "AgentID=" + encodeURIComponent("" + agentID) + "&";
        if (contactType !== undefined && contactType !== null)
            url_ += "ContactType=" + encodeURIComponent("" + contactType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContactInfoByAgentIdForDA(_response);
        });
    }

    protected processGetContactInfoByAgentIdForDA(response: Response): Promise<AgentContactResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentContactResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentContactResponse>(null as any);
    }

    /**
     * @param carrierId (optional) 
     * @param year (optional) 
     * @param product (optional) 
     * @param productTypeId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCertificationDetailsForDA(agentId: number, v: string, carrierId?: number | null | undefined, year?: number | undefined, product?: string | null | undefined, productTypeId?: number | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentCertificationsResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/agentCertifications?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined and cannot be null.");
        else
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (carrierId !== undefined && carrierId !== null)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (product !== undefined && product !== null)
            url_ += "Product=" + encodeURIComponent("" + product) + "&";
        if (productTypeId !== undefined && productTypeId !== null)
            url_ += "ProductTypeId=" + encodeURIComponent("" + productTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCertificationDetailsForDA(_response);
        });
    }

    protected processGetCertificationDetailsForDA(response: Response): Promise<AgentCertificationsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentCertificationsResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentCertificationsResponse>(null as any);
    }

    /**
     * @param carrierName (optional) 
     * @param productType (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getProductionSummaryByAgentIdForDA(agentId: number, v: string, carrierName?: string | null | undefined, productType?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ProductionSummaryResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/productionSummary?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined and cannot be null.");
        else
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (carrierName !== undefined && carrierName !== null)
            url_ += "CarrierName=" + encodeURIComponent("" + carrierName) + "&";
        if (productType !== undefined && productType !== null)
            url_ += "ProductType=" + encodeURIComponent("" + productType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductionSummaryByAgentIdForDA(_response);
        });
    }

    protected processGetProductionSummaryByAgentIdForDA(response: Response): Promise<ProductionSummaryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductionSummaryResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductionSummaryResponse>(null as any);
    }

    /**
     * @param carrierName (optional) 
     * @param productType (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getProductionDetailsForDA(agentId: number, v: string, carrierName?: string | null | undefined, productType?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ProductionDetailsResponse[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/productionDetailsbyProductType?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined and cannot be null.");
        else
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (carrierName !== undefined && carrierName !== null)
            url_ += "CarrierName=" + encodeURIComponent("" + carrierName) + "&";
        if (productType !== undefined && productType !== null)
            url_ += "ProductType=" + encodeURIComponent("" + productType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductionDetailsForDA(_response);
        });
    }

    protected processGetProductionDetailsForDA(response: Response): Promise<ProductionDetailsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductionDetailsResponse[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductionDetailsResponse[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getProductionDetailsByCarrierForDA(agentID: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ProductionDetailsResponse[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/productionDetailsByCarrier?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentID === undefined || agentID === null)
            throw new Error("The parameter 'agentID' must be defined and cannot be null.");
        else
            url_ += "AgentID=" + encodeURIComponent("" + agentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductionDetailsByCarrierForDA(_response);
        });
    }

    protected processGetProductionDetailsByCarrierForDA(response: Response): Promise<ProductionDetailsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductionDetailsResponse[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductionDetailsResponse[]>(null as any);
    }

    /**
     * @param productType (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getProductTypesByAgentIDForDA(agentId: number, v: string, productType?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ProductTypeResponse[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/productTypesForCertification?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined and cannot be null.");
        else
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (productType !== undefined && productType !== null)
            url_ += "ProductType=" + encodeURIComponent("" + productType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductTypesByAgentIDForDA(_response);
        });
    }

    protected processGetProductTypesByAgentIDForDA(response: Response): Promise<ProductTypeResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductTypeResponse[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductTypeResponse[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentProfileByAgentIdForDA(agentID: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentProfileInfoResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/agentProfile?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentID === undefined || agentID === null)
            throw new Error("The parameter 'agentID' must be defined and cannot be null.");
        else
            url_ += "AgentID=" + encodeURIComponent("" + agentID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentProfileByAgentIdForDA(_response);
        });
    }

    protected processGetAgentProfileByAgentIdForDA(response: Response): Promise<AgentProfileInfoResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentProfileInfoResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentProfileInfoResponse>(null as any);
    }

    /**
     * @param policyId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPolicyByPolicyNumberForDA(policyNumber: string, v: string, policyId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PolicyDetails> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/policy?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (policyNumber === undefined || policyNumber === null)
            throw new Error("The parameter 'policyNumber' must be defined and cannot be null.");
        else
            url_ += "PolicyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        if (policyId === null)
            throw new Error("The parameter 'policyId' cannot be null.");
        else if (policyId !== undefined)
            url_ += "PolicyId=" + encodeURIComponent("" + policyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicyByPolicyNumberForDA(_response);
        });
    }

    protected processGetPolicyByPolicyNumberForDA(response: Response): Promise<PolicyDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PolicyDetails;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetails>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCommissionByPolicyIdForDA(policyID: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PolicyDetails> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/policyCommission?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (policyID === undefined || policyID === null)
            throw new Error("The parameter 'policyID' must be defined and cannot be null.");
        else
            url_ += "PolicyID=" + encodeURIComponent("" + policyID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCommissionByPolicyIdForDA(_response);
        });
    }

    protected processGetCommissionByPolicyIdForDA(response: Response): Promise<PolicyDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PolicyDetails;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetails>(null as any);
    }

    /**
     * @param state (optional) 
     * @param city (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getInsuredByNameForDA(insuredName: string, v: string, state?: string | null | undefined, city?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentResponse2> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/insured?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (insuredName === undefined || insuredName === null)
            throw new Error("The parameter 'insuredName' must be defined and cannot be null.");
        else
            url_ += "InsuredName=" + encodeURIComponent("" + insuredName) + "&";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (city !== undefined && city !== null)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInsuredByNameForDA(_response);
        });
    }

    protected processGetInsuredByNameForDA(response: Response): Promise<AgentResponse2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentResponse2;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentResponse2>(null as any);
    }

    /**
     * @param policyId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPolicyByInsuredForDA(customerId: number, v: string, policyId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PolicyDetails> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/policyByInsured?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (policyId === null)
            throw new Error("The parameter 'policyId' cannot be null.");
        else if (policyId !== undefined)
            url_ += "PolicyId=" + encodeURIComponent("" + policyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicyByInsuredForDA(_response);
        });
    }

    protected processGetPolicyByInsuredForDA(response: Response): Promise<PolicyDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PolicyDetails;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyDetails>(null as any);
    }

    /**
     * @param distanceToBeCovered (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentsbyGeolocationForDA(zipCode: string, carrier: number, v: string, distanceToBeCovered?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentSearchByGeolocationResponse[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/agentsByGeolocation?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (zipCode === undefined || zipCode === null)
            throw new Error("The parameter 'zipCode' must be defined and cannot be null.");
        else
            url_ += "ZipCode=" + encodeURIComponent("" + zipCode) + "&";
        if (carrier === undefined || carrier === null)
            throw new Error("The parameter 'carrier' must be defined and cannot be null.");
        else
            url_ += "Carrier=" + encodeURIComponent("" + carrier) + "&";
        if (distanceToBeCovered === null)
            throw new Error("The parameter 'distanceToBeCovered' cannot be null.");
        else if (distanceToBeCovered !== undefined)
            url_ += "distanceToBeCovered=" + encodeURIComponent("" + distanceToBeCovered) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentsbyGeolocationForDA(_response);
        });
    }

    protected processGetAgentsbyGeolocationForDA(response: Response): Promise<AgentSearchByGeolocationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentSearchByGeolocationResponse[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentSearchByGeolocationResponse[]>(null as any);
    }

    /**
     * @param distanceToBeCovered (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    generateExcelAgentsByGeolocation(zipCode: string, carrier: number, v: string, distanceToBeCovered?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/generate?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (zipCode === undefined || zipCode === null)
            throw new Error("The parameter 'zipCode' must be defined and cannot be null.");
        else
            url_ += "ZipCode=" + encodeURIComponent("" + zipCode) + "&";
        if (carrier === undefined || carrier === null)
            throw new Error("The parameter 'carrier' must be defined and cannot be null.");
        else
            url_ += "Carrier=" + encodeURIComponent("" + carrier) + "&";
        if (distanceToBeCovered === null)
            throw new Error("The parameter 'distanceToBeCovered' cannot be null.");
        else if (distanceToBeCovered !== undefined)
            url_ += "distanceToBeCovered=" + encodeURIComponent("" + distanceToBeCovered) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateExcelAgentsByGeolocation(_response);
        });
    }

    protected processGenerateExcelAgentsByGeolocation(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param lastName (optional) 
     * @param firstName (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentInfoByName(v: string, lastName?: string | null | undefined, firstName?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentInfoResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/da/agentinfobyname?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentInfoByName(_response);
        });
    }

    protected processGetAgentInfoByName(response: Response): Promise<AgentInfoResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentInfoResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentInfoResponse>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllEmailCommunication(agentId: number, v: string, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<EmailCommunicationResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/emailcommunication?";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllEmailCommunication(_response);
        });
    }

    protected processGetAllEmailCommunication(response: Response): Promise<EmailCommunicationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailCommunicationResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailCommunicationResponse>(null as any);
    }

    /**
     * @param attachmentFileGuid (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    downloadEmailCommunicationAttachment(v: string, attachmentFileGuid?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<DownloadFileModel> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/downloademailcommunicationattachment?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (attachmentFileGuid !== undefined && attachmentFileGuid !== null)
            url_ += "AttachmentFileGuid=" + encodeURIComponent("" + attachmentFileGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadEmailCommunicationAttachment(_response);
        });
    }

    protected processDownloadEmailCommunicationAttachment(response: Response): Promise<DownloadFileModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadFileModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadFileModel>(null as any);
    }

    /**
     * @param buShortName (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllAgents(v: string, buShortName?: string | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentsResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/HubSpot?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (buShortName !== undefined && buShortName !== null)
            url_ += "BuShortName=" + encodeURIComponent("" + buShortName) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllAgents(_response);
        });
    }

    protected processGetAllAgents(response: Response): Promise<AgentsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentsResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    updateMarketingEmailStatus(businessUnitShortName: string | null, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/updatemarketingeventemailstatus/{businessUnitShortName}";
        if (businessUnitShortName === undefined || businessUnitShortName === null)
            throw new Error("The parameter 'businessUnitShortName' must be defined.");
        url_ = url_.replace("{businessUnitShortName}", encodeURIComponent("" + businessUnitShortName));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMarketingEmailStatus(_response);
        });
    }

    protected processUpdateMarketingEmailStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    sendSendGridMarketingEmailRequest(businessUnitShortName: string | null, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/producer/v{v}/sendsendgridmarketingemailrequest/{businessUnitShortName}";
        if (businessUnitShortName === undefined || businessUnitShortName === null)
            throw new Error("The parameter 'businessUnitShortName' must be defined.");
        url_ = url_.replace("{businessUnitShortName}", encodeURIComponent("" + businessUnitShortName));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendSendGridMarketingEmailRequest(_response);
        });
    }

    protected processSendSendGridMarketingEmailRequest(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    receiveMarketingEmail(businessUnitShortName: string | null, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/producer/v{v}/receivemarketingemail/{businessUnitShortName}";
        if (businessUnitShortName === undefined || businessUnitShortName === null)
            throw new Error("The parameter 'businessUnitShortName' must be defined.");
        url_ = url_.replace("{businessUnitShortName}", encodeURIComponent("" + businessUnitShortName));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReceiveMarketingEmail(_response);
        });
    }

    protected processReceiveMarketingEmail(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param calendervisibledate (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllMarketingEvents(v: string, calendervisibledate?: Date | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<MarketingEventsResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketingevents?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (calendervisibledate === null)
            throw new Error("The parameter 'calendervisibledate' cannot be null.");
        else if (calendervisibledate !== undefined)
            url_ += "calendervisibledate=" + encodeURIComponent(calendervisibledate ? "" + calendervisibledate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllMarketingEvents(_response);
        });
    }

    protected processGetAllMarketingEvents(response: Response): Promise<MarketingEventsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketingEventsResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingEventsResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    addMarketingEvent(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: MarketingEventModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketingevents";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddMarketingEvent(_response);
        });
    }

    protected processAddMarketingEvent(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateMarketingEvent(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: MarketingEventModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketingevents";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMarketingEvent(_response);
        });
    }

    protected processUpdateMarketingEvent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteMarketingEvent(v: string, id?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketingevents?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteMarketingEvent(_response);
        });
    }

    protected processDeleteMarketingEvent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getMarketingEventById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<MarketingEventDetailModel> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketingevents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMarketingEventById(_response);
        });
    }

    protected processGetMarketingEventById(response: Response): Promise<MarketingEventDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketingEventDetailModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getmarketingeventlookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<MarketingEventLookupRepsonse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketingevents/getmarketingeventlookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetmarketingeventlookup(_response);
        });
    }

    protected processGetmarketingeventlookup(response: Response): Promise<MarketingEventLookupRepsonse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketingEventLookupRepsonse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingEventLookupRepsonse>(null as any);
    }

    /**
     * @param id (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getStatisticsReport(v: string, id?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketingevents/statisticsreport?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStatisticsReport(_response);
        });
    }

    protected processGetStatisticsReport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param id (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getResendListReport(v: string, id?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketingevents/resendlistreport?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetResendListReport(_response);
        });
    }

    protected processGetResendListReport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    homeScreenKPILookup(v: string, startDate?: Date | undefined, endDate?: Date | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<HomeScreenKPIResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketingevents/homescreenkpislookup?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHomeScreenKPILookup(_response);
        });
    }

    protected processHomeScreenKPILookup(response: Response): Promise<HomeScreenKPIResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HomeScreenKPIResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HomeScreenKPIResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getTop5MarketingEvents(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<Top5MarketingEventsModel[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketingevents/gettop5marketingevents";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTop5MarketingEvents(_response);
        });
    }

    protected processGetTop5MarketingEvents(response: Response): Promise<Top5MarketingEventsModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Top5MarketingEventsModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Top5MarketingEventsModel[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getEmailPreferencesDetailByAgentId(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<EmailPreferencesDetailModel[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketingevents/emailpreferences/{agentId}";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmailPreferencesDetailByAgentId(_response);
        });
    }

    protected processGetEmailPreferencesDetailByAgentId(response: Response): Promise<EmailPreferencesDetailModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailPreferencesDetailModel[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    sendMarketingEventEmail(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: SendEmailMarketingEventRequestModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketingevents/sendemail";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendMarketingEventEmail(_response);
        });
    }

    protected processSendMarketingEventEmail(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createAgentContactEmailUnsubscribe(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateAgentContactEmailUnsubscribeModel[] | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketingevents/emailpreferences/createagentcontactemailunsubscribe";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAgentContactEmailUnsubscribe(_response);
        });
    }

    protected processCreateAgentContactEmailUnsubscribe(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    getMarketingEventWebViewerUrl(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: MarketingEventWebViewerUrlRequest | undefined): Promise<MarketingEventWebViewerUrlResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketingevents/GetMarketingEventWebViewerUrl";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMarketingEventWebViewerUrl(_response);
        });
    }

    protected processGetMarketingEventWebViewerUrl(response: Response): Promise<MarketingEventWebViewerUrlResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketingEventWebViewerUrlResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingEventWebViewerUrlResponse>(null as any);
    }

    /**
     * @param id (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getMarketingEventListByEventId(v: string, id?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<MarketingEventEmailListResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketereventlist/GetMarketingEventListByEventId?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMarketingEventListByEventId(_response);
        });
    }

    protected processGetMarketingEventListByEventId(response: Response): Promise<MarketingEventEmailListResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketingEventEmailListResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketingEventEmailListResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getMarketingEventListById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<MarketingEventEmailListDetailModel> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketereventlist/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMarketingEventListById(_response);
        });
    }

    protected processGetMarketingEventListById(response: Response): Promise<MarketingEventEmailListDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketingEventEmailListDetailModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    addMarketingEventList(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: MarketingEventListModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketereventlist";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddMarketingEventList(_response);
        });
    }

    protected processAddMarketingEventList(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param id (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deletMarketingEventList(v: string, id?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketereventlist?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletMarketingEventList(_response);
        });
    }

    protected processDeletMarketingEventList(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param id (optional) 
     * @param newEmailsText (optional) 
     * @param isFile (optional) 
     * @param file (optional) 
     * @return Success
     */
    addMarketingEventEmail(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, id?: number | undefined, newEmailsText?: string | null | undefined, isFile?: boolean | undefined, file?: FileParameter | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketereventlist/addnewemails";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (newEmailsText !== null && newEmailsText !== undefined)
            content_.append("NewEmailsText", newEmailsText.toString());
        if (isFile === null || isFile === undefined)
            throw new Error("The parameter 'isFile' cannot be null.");
        else
            content_.append("IsFile", isFile.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddMarketingEventEmail(_response);
        });
    }

    protected processAddMarketingEventEmail(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param id (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteMarketingEventEmail(v: string, id?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/marketereventlist/removeallemails?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteMarketingEventEmail(_response);
        });
    }

    protected processDeleteMarketingEventEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param noteTypeId (optional) 
     * @param noteSearch (optional) 
     * @param companyId (optional) 
     * @param isIncludeInactiveCarrier (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllNote(agentId: number, v: string, userId?: number | undefined, noteTypeId?: number | undefined, noteSearch?: string | null | undefined, companyId?: number | undefined, isIncludeInactiveCarrier?: boolean | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<NoteSearchResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/notes?";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (noteTypeId === null)
            throw new Error("The parameter 'noteTypeId' cannot be null.");
        else if (noteTypeId !== undefined)
            url_ += "NoteTypeId=" + encodeURIComponent("" + noteTypeId) + "&";
        if (noteSearch !== undefined && noteSearch !== null)
            url_ += "NoteSearch=" + encodeURIComponent("" + noteSearch) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (isIncludeInactiveCarrier === null)
            throw new Error("The parameter 'isIncludeInactiveCarrier' cannot be null.");
        else if (isIncludeInactiveCarrier !== undefined)
            url_ += "IsIncludeInactiveCarrier=" + encodeURIComponent("" + isIncludeInactiveCarrier) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllNote(_response);
        });
    }

    protected processGetAllNote(response: Response): Promise<NoteSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteSearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createNote(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: NoteModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/notes";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNote(_response);
        });
    }

    protected processCreateNote(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateNote(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: NoteModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/notes";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateNote(_response);
        });
    }

    protected processUpdateNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getNoteBy(agentId: number, id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<NoteDetailModel> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/notes/{id}";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNoteBy(_response);
        });
    }

    protected processGetNoteBy(response: Response): Promise<NoteDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteDetailModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteDetailModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPayoutLevelByCompanyId(companyid: number, v: string, agentId: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<NotePayoutLevelDetailModel> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/notes/payoutLevels/{companyid}";
        if (companyid === undefined || companyid === null)
            throw new Error("The parameter 'companyid' must be defined.");
        url_ = url_.replace("{companyid}", encodeURIComponent("" + companyid));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPayoutLevelByCompanyId(_response);
        });
    }

    protected processGetPayoutLevelByCompanyId(response: Response): Promise<NotePayoutLevelDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotePayoutLevelDetailModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotePayoutLevelDetailModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getNoteTypesLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/notetypeslookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNoteTypesLookup(_response);
        });
    }

    protected processGetNoteTypesLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getSaleTypeLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/saletypelookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSaleTypeLookup(_response);
        });
    }

    protected processGetSaleTypeLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getNoteScreenLookups(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<NoteScreenLookupResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/notescreenlookups";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetNoteScreenLookups(_response);
        });
    }

    protected processGetNoteScreenLookups(response: Response): Promise<NoteScreenLookupResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteScreenLookupResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteScreenLookupResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    pinUnpinNote(noteId: number, pinned: boolean, agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/pinunpinnote/{noteId}/{pinned}/{agentId}";
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        if (pinned === undefined || pinned === null)
            throw new Error("The parameter 'pinned' must be defined.");
        url_ = url_.replace("{pinned}", encodeURIComponent("" + pinned));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPinUnpinNote(_response);
        });
    }

    protected processPinUnpinNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    checkPinnedNote(noteId: number, agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/checkpinnednote/{noteId}/{agentId}";
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckPinnedNote(_response);
        });
    }

    protected processCheckPinnedNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteNote(v: string, id?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteNote(_response);
        });
    }

    protected processDeleteNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllPayee(agentId: number, v: string, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PayeeSearchResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/payees?";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPayee(_response);
        });
    }

    protected processGetAllPayee(response: Response): Promise<PayeeSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PayeeSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PayeeSearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createPayee(v: string, agentId: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreatePayeeModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/payees";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePayee(_response);
        });
    }

    protected processCreatePayee(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deletePayee(id: number, agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/payees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePayee(_response);
        });
    }

    protected processDeletePayee(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllPrinciple(agentId: number, v: string, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PrincipalSearchResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/principals?";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPrinciple(_response);
        });
    }

    protected processGetAllPrinciple(response: Response): Promise<PrincipalSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrincipalSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrincipalSearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createPrinciple(v: string, agentId: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreatePrincipalModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/principals";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePrinciple(_response);
        });
    }

    protected processCreatePrinciple(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param agentName (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllPrincipalLookup(v: string, agentName?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PrincipalAgentSearchResponseModel> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/principalagentslookup?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentName !== undefined && agentName !== null)
            url_ += "AgentName=" + encodeURIComponent("" + agentName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPrincipalLookup(_response);
        });
    }

    protected processGetAllPrincipalLookup(response: Response): Promise<PrincipalAgentSearchResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrincipalAgentSearchResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrincipalAgentSearchResponseModel>(null as any);
    }

    /**
     * @param searchTerm (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPayingLegalEntitiesLookup(v: string, searchTerm?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<SearchPayingLegalEntityResponseModel> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/payinglegalentitieslookup?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPayingLegalEntitiesLookup(_response);
        });
    }

    protected processGetPayingLegalEntitiesLookup(response: Response): Promise<SearchPayingLegalEntityResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchPayingLegalEntityResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchPayingLegalEntityResponseModel>(null as any);
    }

    /**
     * @param agentName (optional)
     * @param impersonated_User (optional)
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllAgentPrincipalLookup(v: string, agentName?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PrincipalAgentSearchResponseModel> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/agentprincipalagentslookup?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentName !== undefined && agentName !== null)
            url_ += "AgentName=" + encodeURIComponent("" + agentName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllAgentPrincipalLookup(_response);
        });
    }

    protected processGetAllAgentPrincipalLookup(response: Response): Promise<PrincipalAgentSearchResponseModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrincipalAgentSearchResponseModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrincipalAgentSearchResponseModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deletePrinciple(id: number, v: string, agentId: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/agents/{agentId}/principals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePrinciple(_response);
        });
    }

    protected processDeletePrinciple(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllPrincipalAgentsByContractId(contractId: number, v: string, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<PrinicpalAgentsResponse> {
        let url_ = this.baseUrl + "/api/producer/v{v}/principalcontracts/{contractId}/principalagents?";
        if (contractId === undefined || contractId === null)
            throw new Error("The parameter 'contractId' must be defined.");
        url_ = url_.replace("{contractId}", encodeURIComponent("" + contractId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllPrincipalAgentsByContractId(_response);
        });
    }

    protected processGetAllPrincipalAgentsByContractId(response: Response): Promise<PrinicpalAgentsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrinicpalAgentsResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrinicpalAgentsResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getPrinicpalAgentLookup(agentId: number, licenseId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/principalcontracts/{agentId}/{licenseId}/principalagentslookup";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPrinicpalAgentLookup(_response);
        });
    }

    protected processGetPrinicpalAgentLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createPrincipleAgent(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: PrincipalAgentRequest | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/producer/v{v}/principalcontracts/principalagents";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePrincipleAgent(_response);
        });
    }

    protected processCreatePrincipleAgent(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deletePrincipleAgent(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/producer/v{v}/principalcontracts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePrincipleAgent(_response);
        });
    }

    protected processDeletePrincipleAgent(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getCountyWithStateLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/producer/v{v}/reports/countywithstatelookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCountyWithStateLookup(_response);
        });
    }

    protected processGetCountyWithStateLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param delayInSecs (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAzureDelay(v: string, delayInSecs?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/producer/v{v}/reports/azuredelay?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (delayInSecs === null)
            throw new Error("The parameter 'delayInSecs' cannot be null.");
        else if (delayInSecs !== undefined)
            url_ += "delayInSecs=" + encodeURIComponent("" + delayInSecs) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAzureDelay(_response);
        });
    }

    protected processGetAzureDelay(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    getAgentDetailReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: AgentListRequest | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/producer/v{v}/reports/agentdetail";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentDetailReport(_response);
        });
    }

    protected processGetAgentDetailReport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    getContractedAgentListReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: ContractedAgentListRequest | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/producer/v{v}/reports/contractedagentlist";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContractedAgentListReport(_response);
        });
    }

    protected processGetContractedAgentListReport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    getContractedAgentListReport1(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: ContractedAgentListRequest | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/producer/v{v}/reports/contractedagentlist1";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContractedAgentListReport1(_response);
        });
    }

    protected processGetContractedAgentListReport1(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    getAgentWithoutNotesReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: AgentWithoutNotesRequest | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/producer/v{v}/reports/agentwithoutnotes";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentWithoutNotesReport(_response);
        });
    }

    protected processGetAgentWithoutNotesReport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    getProductionReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: ProductionRequest | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/producer/v{v}/reports/production";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductionReport(_response);
        });
    }

    protected processGetProductionReport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    getProductionSummaryReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: ProductionSummaryRequest | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/producer/v{v}/reports/productionsummary";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductionSummaryReport(_response);
        });
    }

    protected processGetProductionSummaryReport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    getMarketerProductionReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: MarketerProductionRequest | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/producer/v{v}/reports/marketerproduction";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMarketerProductionReport(_response);
        });
    }

    protected processGetMarketerProductionReport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    getDemographyAndContactsReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: DemographyAndContactsRequest | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/producer/v{v}/reports/demographyandcontacts";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDemographyAndContactsReport(_response);
        });
    }

    protected processGetDemographyAndContactsReport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    getStateLicensesReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: AgentStateLicenseRequest | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/producer/v{v}/reports/statelicenses";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStateLicensesReport(_response);
        });
    }

    protected processGetStateLicensesReport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }
}

export interface AddressListModel {
    id?: number;
    addressName?: string | undefined;
    latitude?: number;
    line1?: string | undefined;
    longitude?: number;
    zip?: string | undefined;
    isDefault?: boolean;
    isCommission?: boolean;
    isHome?: boolean;
    city?: string | undefined;
    state?: string | undefined;
    county?: string | undefined;
    dateCreated?: Date;
}

export interface AddressSearchResponse {
    recordCount?: number;
    emailAllRecords?: AddressListModel[] | undefined;
    data?: AddressListModel[] | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export interface CreateUpdateAddressModel {
    id?: number;
    address?: string | undefined;
    addressName?: string | undefined;
    addressNote?: string | undefined;
    addressLine1?: string | undefined;
    zipCode?: string | undefined;
    attn?: string | undefined;
    bussinessName?: string | undefined;
    doNotCall?: boolean;
    doNotEmail?: boolean;
    doNotMarket?: boolean;
    isVisibleInDownline?: boolean;
    securityAccessCode?: string | undefined;
    visibleInUpline?: boolean;
    city?: string | undefined;
    countyName?: string | undefined;
    stateAbbreviation?: string | undefined;
    lattitude?: number;
    longitude?: number;
    agentId?: number;
    isDefault?: boolean;
    isCommission?: boolean;
    isHome?: boolean;
    addressee?: string | undefined;
    firmName?: string | undefined;
    deliveryPointBarcode?: string | undefined;
    primaryNumber?: string | undefined;
    streetName?: string | undefined;
    streetPredirection?: string | undefined;
    streetPostdirection?: string | undefined;
    streetSuffix?: string | undefined;
    secondaryNumber?: string | undefined;
    secondaryDesignator?: string | undefined;
    cityName?: string | undefined;
    defaultCityName?: string | undefined;
    plusFourCode?: string | undefined;
    deliveryPoint?: string | undefined;
    deliveryPointCheckDigit?: string | undefined;
    recordType?: string | undefined;
    zipType?: string | undefined;
    countyFips?: string | undefined;
    carrierRoute?: string | undefined;
    congressionalDistrict?: string | undefined;
    buildingDefaultIndicator?: string | undefined;
    rdi?: string | undefined;
    elotSequence?: string | undefined;
    elotSort?: string | undefined;
    location?: string | undefined;
    precision?: string | undefined;
    dpvCmra?: string | undefined;
    dpvVacant?: string | undefined;
    active?: string | undefined;
    ewsMatch?: boolean | undefined;
    footnotes?: string | undefined;
    lacslinkCode?: string | undefined;
    lacslinkIndicator?: string | undefined;
    suitelinkMatch?: boolean | undefined;
    dpvMatchCode?: string | undefined;
    dpvFootnotes?: string | undefined;
    addressComments?: string | undefined;
    addressType?: number;
    isValid?: boolean;
}

export interface AddressModel {
    address?: string | undefined;
    addressName?: string | undefined;
    addressNote?: string | undefined;
    addressLine1?: string | undefined;
    zipCode?: string | undefined;
    attn?: string | undefined;
    bussinessName?: string | undefined;
    commissionAddressId?: number;
    defaultAddressId?: number;
    isDefault?: boolean;
    isCommission?: boolean;
    isHome?: boolean;
    id?: number;
    visibleInDownline?: boolean;
    residentialAddressId?: number;
    securityAccessCode?: string | undefined;
    visibleInUpline?: boolean;
    city?: string | undefined;
    stateAbbreviation?: string | undefined;
    lattitude?: number;
    longitude?: number;
    agentId?: number;
    addressLine2?: string | undefined;
    lastLine?: string | undefined;
    countyName?: string | undefined;
    plusFourCode?: string | undefined;
    isValid?: boolean;
    addressType?: number;
}

export interface ListItem {
    value?: string | undefined;
    text?: string | undefined;
    selected?: boolean;
}

export interface BankAccountDetailModel {
    bankId?: number | undefined;
    accountNumber?: string | undefined;
    bankAccountTypeId?: number | undefined;
    bankAccountPaymentMethodId?: number;
    bankAccountId?: number;
    agentId?: number;
    bankName?: string | undefined;
}

export interface CustAttrToEntityModel {
    customAttributeScreenId?: number;
    entityId?: number;
    value?: string | undefined;
}

export interface UpdateAgentModel {
    isIntegrityOwnedLegalEntity?: boolean;
    legalEntity?: PayingLegalEntityModel | undefined;
    debtLevelId?: number;
    excludeFromTrip?: boolean;
    isLocation?: boolean;
    onlyPobox?: boolean;
    marketer?: boolean;
    isHiddenAgentProfile?: boolean;
    federallyFacilitatedMarketplaceUserId?: string | undefined;
    terminatedOption?: number | undefined;
    ltcrating?: string | undefined;
    lifeRating?: string | undefined;
    healthRating?: string | undefined;
    annuityRating?: string | undefined;
    finalExpenseRating?: string | undefined;
    healthRatingLocked?: boolean;
    zip?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    eoParticipant?: boolean;
    eoParticipantExpirationDate?: Date | undefined;
    isIntegrityPlatformPartner?: boolean;
    doNotCall?: boolean;
    doNotEmail?: boolean;
    doNotMarket?: boolean;
    id?: number;
    dob?: Date | undefined;
    isAgency?: boolean;
    firstName?: string | undefined;
    lastName: string;
    middle?: string | undefined;
    alternativeLastName?: string | undefined;
    suffix?: string | undefined;
    gender?: string | undefined;
    status?: number | undefined;
    tin?: string | undefined;
    agency?: string | undefined;
    dba?: string | undefined;
    nickName?: string | undefined;
    npn?: string | undefined;
    webSite?: string | undefined;
    leadSource?: number;
    ssn?: string | undefined;
    encryptedSSN?: string | undefined;
    isUserCanSeeThisAgent?: boolean;
    w9?: Date | undefined;
    smr?: number | undefined;
    lhr?: number | undefined;
    sureLC?: boolean | undefined;
    vested?: boolean;
    agentGroup?: number[] | undefined;
    agentGroups?: ListItem[] | undefined;
    leadSources?: ListItem[] | undefined;
    statuses?: ListItem[] | undefined;
    suffixes?: ListItem[] | undefined;
    debtLevels?: ListItem[] | undefined;
    bankAccountTypes?: ListItem[] | undefined;
    bankAccountPaymentMethods?: ListItem[] | undefined;
    marketClassifications?: ListItem[] | undefined;
    creditCheckVendors?: ListItem[] | undefined;
    bankAccountModel?: BankAccountDetailModel;
    smrs?: ListItem[] | undefined;
    lhrs?: ListItem[] | undefined;
    uplines?: ListItem[] | undefined;
    vestedPercentage?: number | undefined;
    uplineId?: number | undefined;
    isPayeeHold?: boolean | undefined;
    customAttributes?: CustAttrToEntityModel[] | undefined;
}

export interface CreatePrincipalModel {
    id?: number;
    agentId?: number;
    principalAgentId?: number;
}

export interface CreateAgentModel {
    id?: number;
    dob?: Date | undefined;
    isAgency?: boolean;
    firstName?: string | undefined;
    lastName: string;
    middleName?: string | undefined;
    alternativeLastName?: string | undefined;
    suffix?: string | undefined;
    gender?: string | undefined;
    status?: number | undefined;
    tin?: string | undefined;
    agency?: string | undefined;
    dba?: string | undefined;
    isIntegrityOwnedLegalEntity?: boolean;
    legalEntityId?: number | undefined;
    legalEntityBUName?: string | undefined;
    nickName?: string | undefined;
    npn?: string | undefined;
    webSite?: string | undefined;
    leadSource?: number;
    ssn?: string | undefined;
    encryptedSSN?: string | undefined;
    w9?: Date | undefined;
    smr?: number | undefined;
    lhr?: number | undefined;
    leadSources?: ListItem[] | undefined;
    statuses?: ListItem[] | undefined;
    suffixes?: ListItem[] | undefined;
    smrs?: ListItem[] | undefined;
    lhrs?: ListItem[] | undefined;
    principalAgentList?: CreatePrincipalModel[] | undefined;
    agentGroup?: number[] | undefined;
    customAttribute?: CustAttrToEntityModel[] | undefined;
}

export interface MarketingPreferencesResponse {
    health?: boolean;
    lifeAnnuities?: boolean;
    funeralTrustOrFinalExpense?: boolean;
    longTermCare?: boolean;
}

export interface AgentSummaryNote {
    noteId?: number;
    userId?: number;
    name?: string | undefined;
    noOfDaysSinceNote?: number;
}

export interface AgentSummaryGroup {
    id?: number;
    name?: string | undefined;
}

export interface AgentSummaryHierarchy {
    agentId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export interface AgentSummaryMarketer {
    marketerId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nickname?: string | undefined;
    divisionId?: number;
    abbreviation?: string | undefined;
}

export interface ContactModel {
    agentId?: number;
    id?: number;
    default?: boolean;
    commission?: boolean;
    contactType?: string | undefined;
    contactTypeId?: number;
    contactValue?: string | undefined;
    description?: string | undefined;
    createdByUserId?: number;
    dateCreated?: Date;
    enableSMS?: boolean;
    phoneType?: string | undefined;
    emailType?: string | undefined;
    alternativePointOfContactType?: string | undefined;
    category?: string | undefined;
    isUnsubscribed?: boolean | undefined;
}

export interface AgentSummaryModel {
    id?: number;
    name?: string | undefined;
    nickName?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    statusText?: string | undefined;
    dba?: string | undefined;
    smr?: string | undefined;
    npn?: string | undefined;
    ssn?: string | undefined;
    tin?: string | undefined;
    gender?: string | undefined;
    source?: string | undefined;
    lhr?: string | undefined;
    dob?: Date | undefined;
    eoExpirationDate?: Date | undefined;
    website?: string | undefined;
    currentTime?: string | undefined;
    workflowCount?: number;
    orderCount?: number;
    badRatingVisible?: boolean;
    badRatingText?: string | undefined;
    isAgency?: boolean;
    age?: number | undefined;
    leadSourceId?: number;
    enableLogin?: boolean;
    receivePaperStatement?: boolean;
    isHiddenAgentProfile?: boolean;
    isIntegrityPlatformPartner?: boolean;
    w9?: Date | undefined;
    sureLC?: boolean | undefined;
    isUserCanSeeThisAgent?: boolean;
    notes?: AgentSummaryNote[] | undefined;
    agentGroups?: AgentSummaryGroup[] | undefined;
    hierarchies?: AgentSummaryHierarchy[] | undefined;
    marketers?: AgentSummaryMarketer[] | undefined;
    contacts?: ContactModel[] | undefined;
    addresses?: AddressListModel[] | undefined;
    agencyReference?: ListItem[] | undefined;
    agentAWNs?: string[] | undefined;
    version?: number | undefined;
    county?: string | undefined;
}

export interface AgentMarketersModel {
    agentMarketers?: ListItem[] | undefined;
    agentMarketersVisible?: boolean;
    agentMarketersEnabled?: boolean;
}

export interface AgentSummaryHierarchyResponse {
    agentSummaryHierarchies?: AgentSummaryHierarchy[] | undefined;
}

export interface AgentProfileInfoModel {
    id?: number;
    name?: string | undefined;
    dba?: string | undefined;
    nickName?: string | undefined;
    defaultEmail?: string | undefined;
    gender?: string | undefined;
    isAgency?: boolean;
}

export interface AgencyListModel {
    agentId?: number;
    agentName?: string | undefined;
    tin?: string | undefined;
}

export interface AgencySearchResponse {
    recordCount?: number;
    emailAllRecords?: AgencyListModel[] | undefined;
    data?: AgencyListModel[] | undefined;
}

export interface DownloadProfilePicModel {
    imageData?: string | undefined;
    message?: string | undefined;
}

export interface AgentResponse {
    isDuplicate?: boolean;
    existingAgentId?: number;
    error?: string | undefined;
    isDuplicateNPN?: boolean;
    agentId?: number;
}

export interface AgentMarketerSearchResponse {
    recordCount?: number;
    emailAllRecords?: ListItem[] | undefined;
    data?: ListItem[] | undefined;
}

export interface AgentStatusByIdResponse {
    status?: string | undefined;
}

export interface AgentCurrentTimeResponse {
    currentTime?: string | undefined;
}

export interface AgentImmediateUpline {
    term?: string | undefined;
    agentId?: number;
    agentName?: string | undefined;
    status?: string | undefined;
}

export interface AgentImmediateUplineResponse {
    recordCount?: number;
    emailAllRecords?: AgentImmediateUpline[] | undefined;
    data?: AgentImmediateUpline[] | undefined;
}

export interface AgentHierarchyDetailsResponse {
    parentId?: number | undefined;
    selfUpline?: boolean;
    agentName?: string | undefined;
    hierarchyLevelId?: number | undefined;
}

export interface AgentHierarchy {
    key?: string | undefined;
    label?: string | undefined;
    selected?: boolean;
    parentId?: number;
    agentLevel?: string | undefined;
    agentStatus?: string | undefined;
    agentNPN?: string | undefined;
    isAgency?: boolean;
    children?: AgentHierarchy[] | undefined;
}

export interface AgentHierarchyResponse {
    hierarchy?: AgentHierarchy;
}

export interface ReportFile {
    title?: string | undefined;
    data?: string | undefined;
    contentType?: string | undefined;
    fileName?: string | undefined;
}

export interface MergeAgentPreviewRequestModel {
    fromMailId: number;
    toMailId: number;
    bankAccountId: number;
    sameBankAccount: boolean;
}

export interface BankAccountModel {
    bankAccountId?: number;
    bankName?: string | undefined;
    accountNumber?: string | undefined;
    bankAccountPaymentMethodName?: string | undefined;
    bankAccountTypeName?: string | undefined;
    bankAccountPaymentMethodId?: number | undefined;
    bankAccountTypeId?: number | undefined;
}

export interface MergeAgentPreviewResponseModel {
    fromAgentId?: number;
    toAgentId?: number;
    fromStatus?: string | undefined;
    toStatus?: string | undefined;
    fromCityStateZip?: string | undefined;
    toCityStateZip?: string | undefined;
    fromNPN?: string | undefined;
    toNPN?: string | undefined;
    fromFullName?: string | undefined;
    toFullName?: string | undefined;
    fromPoliciesCount?: string | undefined;
    toPoliciesCount?: string | undefined;
    fromAgentNoteCount?: string | undefined;
    toAgentNoteCount?: string | undefined;
    fromDocCount?: string | undefined;
    toDocCount?: string | undefined;
    message?: string | undefined;
    bankAccount?: BankAccountModel[] | undefined;
    sameBankRecord?: boolean;
}

export interface SaveAgentMarketerRequest {
    agentId?: number;
    agentMarketerId?: number;
}

export interface CreateUpdateContactModel {
    id?: number;
    contactTypeId?: number;
    contactValue?: string | undefined;
    description?: string | undefined;
    agentId?: number;
    createdByUserId?: number;
    dateCreated?: Date;
    enableSMS?: boolean;
    phoneTypeId?: number | undefined;
    emailTypeID?: number | undefined;
    alternativePointOfContactTypeID?: number | undefined;
    isDefault?: boolean;
    isCommission?: boolean;
}

export interface UpdateAgentHierarchyRequest {
    agentId?: number;
    parentId?: number;
    selfUpline?: boolean;
    hierarchyLevelId?: number | undefined;
}

export interface CreateConnectAgentWithContactsModel {
    agentDetails?: CreateAgentModel;
    agentPhoneNumberDetails?: CreateUpdateContactModel;
    agentEmailAddressDetails?: CreateUpdateContactModel;
    hierarchyRequest?: UpdateAgentHierarchyRequest;
}

export interface CreateConnectAgentModel {
    id?: number;
    dob?: Date | undefined;
    isAgency?: boolean;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    alternativeLastName?: string | undefined;
    suffix?: string | undefined;
    gender?: string | undefined;
    status?: number | undefined;
    tin?: string | undefined;
    agency?: string | undefined;
    dba?: string | undefined;
    nickName?: string | undefined;
    npn?: string | undefined;
    webSite?: string | undefined;
    leadSource?: number;
    ssn?: string | undefined;
    encryptedSSN?: string | undefined;
    email?: string | undefined;
    active?: boolean;
    recruiterID?: string | undefined;
    uplineId?: string | undefined;
    businessUnitShortName?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    phoneNumber?: string | undefined;
    county?: string | undefined;
    registrationId?: string | undefined;
}

export interface AgentProfileLoginModel {
    agentId?: number;
    enableLogin?: boolean;
}

export interface AgentReceivePaperStatementModel {
    agentId?: number;
    receivePaperStatement?: boolean;
}

export interface MarketingPreferencesModel {
    health?: boolean;
    lifeAnnuities?: boolean;
    funeralTrustOrFinalExpense?: boolean;
    longTermCare?: boolean;
    agentId?: number;
    email?: string | undefined;
}

export interface UploadProfilePicModel {
    agentId?: number;
    image?: string | undefined;
}

export interface DocumentAttachment {
    mappingId?: number;
    documentId?: number;
    isDeleted?: boolean;
    documentName?: string | undefined;
    companyName?: string | undefined;
    fileType?: string | undefined;
}

export interface AddressModel2 {
    id?: number;
    addressName?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    zipCode?: string | undefined;
    cityName?: string | undefined;
    county?: string | undefined;
    stateAbbreviation?: string | undefined;
}

export interface UpdateAgentW9InformationRequest {
    documentAttachmentList?: DocumentAttachment[] | undefined;
    taxpayerBusinessName?: string | undefined;
    taxpayerName?: string | undefined;
    ein?: string | undefined;
    w9SSN?: string | undefined;
    federalTaxClassificationId?: number;
    federalTaxClassificationOptionId?: string | undefined;
    eligibility1099: boolean;
    w9AddressID?: number | undefined;
    taxPayerId?: number;
    address?: AddressModel2;
    agentId?: number;
    version?: number;
}

export interface AlertByAgentIdResponse {
    id?: number;
    alert?: string | undefined;
    agentId?: number;
    agentName?: string | undefined;
    createdBy?: string | undefined;
    createdDate?: string | undefined;
    modifiedBy?: string | undefined;
    modifiedDate?: string | undefined;
}

export interface CreateUpdateAlertRequestModel {
    alert?: string | undefined;
    agentId?: number;
}

export interface ContactByAgentIdResponse {
    recordCount?: number;
    emailAllRecords?: ContactModel[] | undefined;
    data?: ContactModel[] | undefined;
    isDNxOverride?: boolean;
    showManageSubscriptions?: boolean;
    showPhoneTab?: boolean;
    showEmailTab?: boolean;
}

export interface ContactByIdModel {
    contactTypeId?: number;
    contactValue?: string | undefined;
    description?: string | undefined;
    id?: number;
    enableSMS?: boolean;
    phoneTypeId?: number;
    emailTypeId?: number;
    alternativePointOfContactTypeId?: number;
    default?: boolean;
    commission?: boolean;
}

export interface ContactSMSBodyModel {
    body?: string | undefined;
    agentName?: string | undefined;
    userName?: string | undefined;
    sentDateTime?: Date;
    isOutBound?: boolean;
    isMessageRead?: boolean;
}

export interface ContactSMSMessageGroupModel {
    messageDate?: Date;
    contactSMSBodyModels?: ContactSMSBodyModel[] | undefined;
}

export interface ContactSMSBodyResponse {
    totalCount?: number;
    recordCount?: number;
    contactSMSMessageGroupModels?: ContactSMSMessageGroupModel[] | undefined;
}

export interface AssociatedProfile {
    agentId?: number;
    agentName?: string | undefined;
    status?: string | undefined;
}

export interface PhonePreferenceModel {
    agentId?: number;
    phoneNumber?: string | undefined;
    category?: string | undefined;
    associatedProfileCount?: number;
    isPhoneUnsubscribed?: boolean | undefined;
    associatedProfiles?: AssociatedProfile[] | undefined;
}

export interface PhonePreferenceByAgentIdResponse {
    recordCount?: number;
    emailAllRecords?: PhonePreferenceModel[] | undefined;
    data?: PhonePreferenceModel[] | undefined;
}

export interface SendTextMessageRequest {
    contactId?: number;
    body?: string | undefined;
    agentId?: number;
}

export interface PhoneUnsubscribeModel {
    phoneNumber?: string | undefined;
    isPhoneUnsubscribed?: boolean;
}

export interface UpdatePhonePreferenceModel {
    phoneUnsubscribeModel?: PhoneUnsubscribeModel[] | undefined;
    id?: number;
}

export interface ContractApproversResponse {
    isApproved?: boolean;
}

export interface AgentResponse2 {
    agentId?: number;
    firstName?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    nickName?: string | undefined;
    city?: string | undefined;
    stateCode?: string | undefined;
    state?: string | undefined;
}

export interface CommissionSummaryResponse {
    ytdAmount?: number;
    prevYtdAmount?: number;
    ytdPercentage?: number;
    ytdIndicator?: string | undefined;
    ltmAmount?: number;
    prevLtmAmount?: number;
    ltmIndicator?: string | undefined;
    ltmPercentage?: number;
}

export interface CarrierResponse {
    carrierId?: number;
    carrierName?: string | undefined;
}

export interface CommissionDetailResponse {
    productType?: string | undefined;
    commissionAmount?: number;
    level?: string | undefined;
}

export interface ProductTypeResponse {
    productTypeId?: number;
    productTypeName?: string | undefined;
}

export interface AwnDetails {
    awnNumber?: string | undefined;
    type?: string | undefined;
    isWritable?: boolean;
}

export interface ContractProductDetails {
    productType?: string | undefined;
    productName?: string | undefined;
    level?: string | undefined;
}

export interface ContractDetails {
    contractId?: number;
    startDate?: Date;
    endDate?: Date | undefined;
    status?: string | undefined;
    statusReason?: string | undefined;
    awnDetails?: AwnDetails[] | undefined;
    productDetails?: ContractProductDetails[] | undefined;
}

export interface PayoutResponse {
    contractDetails?: ContractDetails[] | undefined;
}

export interface AgentInfo {
    contractId?: number;
    agentId?: number;
    firstName?: string | undefined;
    name?: string | undefined;
    lastName?: string | undefined;
    awnNumber?: string | undefined;
}

export interface AgentHierarchy2 {
    immediateUpline?: AgentInfo;
    toh?: AgentInfo;
    downlineCount?: number;
}

export interface AgentHierarchyDetailsResponse2 {
    contractId?: number;
    startDate?: Date;
    endDate?: Date | undefined;
    status?: string | undefined;
    statusReason?: string | undefined;
    hierarchy?: AgentHierarchy2;
}

export interface AgentHierarchyResponse2 {
    hierarchyList?: AgentHierarchyDetailsResponse2[] | undefined;
}

export interface AgentAddress {
    id?: number;
    name?: string | undefined;
    address?: string | undefined;
    isDefault?: boolean;
    isCommission?: boolean;
    isHome?: boolean;
    longitude?: number | undefined;
    latitude?: number | undefined;
}

export interface AgentAddressResponse {
    recordCount?: number;
    data?: AgentAddress[] | undefined;
}

export interface AgentContact {
    contactType?: string | undefined;
    contactValue?: string | undefined;
    description?: string | undefined;
    isDefault?: boolean;
    isCommission?: boolean;
}

export interface AgentContactResponse {
    recordCount?: number;
    data?: AgentContact[] | undefined;
}

export interface AgentCertifications {
    carrier?: string | undefined;
    product?: string | undefined;
    certificationDate?: Date;
    year?: number;
}

export interface AgentCertificationsResponse {
    recordCount?: number;
    data?: AgentCertifications[] | undefined;
    lastCertified?: AgentCertifications;
}

export interface ProductionSummaryResponse {
    ytdAmount?: number;
    prevYtdAmount?: number;
    ytdPercentage?: number;
    ytdIndicator?: string | undefined;
    ltmProduction?: number;
    prevLtmProduction?: number;
    ltmIndicator?: string | undefined;
    ltmPercentage?: number;
}

export interface ProductionDetailsResponse {
    productType?: string | undefined;
    productionYTD?: number;
    productionLTM?: number;
}

export interface Marketer {
    marketerID?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    name?: string | undefined;
}

export interface AgentGroup {
    id?: number;
    groupName?: string | undefined;
}

export interface AgentProfileInfoResponse {
    dob?: Date | undefined;
    npn?: string | undefined;
    dba?: string | undefined;
    tin?: string | undefined;
    ssn?: string | undefined;
    marketers?: Marketer[] | undefined;
    agentGroups?: AgentGroup[] | undefined;
}

export interface PolicyDetails {
    policyId?: number;
    policyNumber?: string | undefined;
    insuredId?: number;
    insured?: string | undefined;
    carrier?: string | undefined;
    product?: string | undefined;
    writingNumber?: string | undefined;
    issuedDate?: Date | undefined;
    status?: string | undefined;
    agentID?: number;
    agent?: string | undefined;
    marketer?: string | undefined;
    plan?: string | undefined;
    premium?: number;
    annualPremium?: number;
    mode?: string | undefined;
}

export interface AgentSearchByGeolocationResponse {
    agentId?: number;
    agentName?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    carrierId?: number;
    carrierName?: string | undefined;
    longitude?: number | undefined;
    latitude?: number | undefined;
    zipcode?: string | undefined;
}

export interface AgentInfoResponse {
    message?: string | undefined;
}

export interface EmailCommunicationAttachmentModel {
    emailCommunicationId?: number;
    attachmentFileName?: string | undefined;
    attachmentFileGuid?: string | undefined;
}

export interface EmailCommunicationListModel {
    emailCommunicationId?: number;
    agentId?: number | undefined;
    from?: string | undefined;
    subject?: string | undefined;
    bodyText?: string | undefined;
    bodyHTML?: string | undefined;
    createdDate?: Date;
    emailCommunicationAttachments?: EmailCommunicationAttachmentModel[] | undefined;
}

export interface EmailCommunicationResponse {
    recordCount?: number;
    emailAllRecords?: EmailCommunicationListModel[] | undefined;
    data?: EmailCommunicationListModel[] | undefined;
}

export interface DownloadFileModel {
    data?: string | undefined;
    message?: string | undefined;
    fileName?: string | undefined;
}

export interface AgentModel {
    id?: number;
    agentFirstName?: string | undefined;
    agentLastName?: string | undefined;
    dob?: Date | undefined;
    gender?: string | undefined;
    website?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    addressType?: string | undefined;
    address?: string | undefined;
    county?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    marketer?: string | undefined;
    agentStatus?: string | undefined;
}

export interface AgentsResponse {
    recordCount?: number;
    emailAllRecords?: AgentModel[] | undefined;
    data?: AgentModel[] | undefined;
}

export interface MarketingEventSearchModel {
    id?: number;
    marketingEventTypeId?: number;
    marketingEventTypeName?: string | undefined;
    marketingFormatId?: number;
    marketingFormatName?: string | undefined;
    ownerId?: number;
    ownerName?: string | undefined;
    companyId?: number;
    companyName?: string | undefined;
    divisionId?: number;
    divisionName?: string | undefined;
    dateTimeStart?: Date;
    dateTimeEnd?: Date;
    title?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    audience?: string | undefined;
    requestorId?: number | undefined;
    audienceSize?: number | undefined;
    purchasedLead?: boolean | undefined;
    emailSubject?: string | undefined;
    fromEmailAddress?: string | undefined;
    fromDisplayName?: string | undefined;
    replyTo?: string | undefined;
    longRunningMarketingEventGroupId?: number | undefined;
    productLineId?: number;
    displayStartDate?: Date;
}

export interface MarketingEventsResponse {
    marketingEmail?: string | undefined;
    marketingEventsList?: MarketingEventSearchModel[] | undefined;
}

export interface MarketingEventModel {
    id?: number;
    marketingEventTypeId?: number;
    marketingFormatId?: number;
    ownerId?: number;
    companyId?: number;
    divisionId?: number;
    dateStart?: string | undefined;
    dateStop?: string | undefined;
    timeStart?: string | undefined;
    timeStop?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    audience?: string | undefined;
    requestorId?: number | undefined;
    audienceSize?: number | undefined;
    purchasedLead?: boolean | undefined;
    emailSubject?: string | undefined;
    fromEmailAddress?: string | undefined;
    fromDisplayName?: string | undefined;
    replyTo?: string | undefined;
    longRunningMarketingEventGroupId?: number | undefined;
    productLineId?: number;
    displayStartDate?: Date;
}

export interface MarketingEventDetailModel {
    id?: number;
    marketingEventTypeId?: number;
    marketingFormatId?: number;
    ownerId?: number;
    companyId?: number;
    divisionId?: number;
    dateStart?: string | undefined;
    dateStop?: string | undefined;
    timeStart?: string | undefined;
    timeStop?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    url?: string | undefined;
    audience?: string | undefined;
    requestorId?: number | undefined;
    audienceSize?: number | undefined;
    purchasedLead?: boolean | undefined;
    emailSubject?: string | undefined;
    fromEmailAddress?: string | undefined;
    fromDisplayName?: string | undefined;
    replyTo?: string | undefined;
    longRunningMarketingEventGroupId?: number | undefined;
    productLineId?: number;
    displayStartDate?: Date;
    longRunningMarketingEventGroup?: string | undefined;
    requestCount?: string | undefined;
    deliveredCount?: string | undefined;
    openedCount?: string | undefined;
    clickedCount?: string | undefined;
    bouncesCount?: string | undefined;
    spamReportsCount?: string | undefined;
    uniqueClicksCount?: string | undefined;
    uniqueOpensCount?: string | undefined;
    contractedLeads?: string | undefined;
    contractedLeadsPhoneCalls?: string | undefined;
    contractedLeadsUniquePhoneCalls?: string | undefined;
    openLeads?: string | undefined;
    openLeadsPhoneCalls?: string | undefined;
    openLeadsUniquePhoneCalls?: string | undefined;
    nonContractedLeads?: string | undefined;
    nonContractedLeadsPhoneCalls?: string | undefined;
    nonContractedLeadsUniquePhoneCalls?: string | undefined;
    production?: string | undefined;
    unsubscribes?: string | undefined;
    allowedSendMarketingEmail?: boolean;
}

export interface MarketingEventLookupRepsonse {
    longRunningMarketingEventGroups?: ListItem[] | undefined;
    owners?: ListItem[] | undefined;
    requestors?: ListItem[] | undefined;
    companies?: ListItem[] | undefined;
    productLines?: ListItem[] | undefined;
    types?: ListItem[] | undefined;
    formats?: ListItem[] | undefined;
}

export interface CarrierCountModel {
    carrierName?: string | undefined;
    appCount?: number;
}

export interface ProductCountModel {
    subCategoryName?: string | undefined;
    appCount?: number;
}

export interface AgentTripPointModel {
    agentName?: string | undefined;
    totalTripPoints?: number;
}

export interface AppCountMonthYearModel {
    month?: number;
    currentYear?: number;
    previousYear?: number;
}

export interface HomeScreenKPIResponse {
    totalContractsInWorkflow?: number;
    totalAppsInWorkflow?: number;
    livesImpacted?: number;
    contractedAgents?: number;
    carrierCountModels?: CarrierCountModel[] | undefined;
    productCountModels?: ProductCountModel[] | undefined;
    agentTripPointModels?: AgentTripPointModel[] | undefined;
    appCountMonthYearModel?: AppCountMonthYearModel[] | undefined;
}

export interface Top5MarketingEventsModel {
    id?: number;
    marketingFormatName?: string | undefined;
    ownerId?: number;
    ownerName?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    displayStartDate?: Date;
}

export interface EmailPreferencesProductLinesDetail {
    productLineId?: number;
    productLineName?: string | undefined;
    isChecked?: boolean;
}

export interface EmailPreferencesDetailModel {
    emailAddress?: string | undefined;
    emailPreferencesProductLinesDetail?: EmailPreferencesProductLinesDetail[] | undefined;
}

export interface SendEmailMarketingEventRequestModel {
    id?: number;
    testEmailAddress?: string | undefined;
}

export interface EmailPreferencesProductLinesDetail2 {
    productLineId?: number;
    productLineName?: string | undefined;
    isChecked?: boolean;
}

export interface CreateAgentContactEmailUnsubscribeModel {
    emailAddress?: string | undefined;
    emailPreferencesProductLinesDetail?: EmailPreferencesProductLinesDetail2[] | undefined;
}

export interface MarketingEventWebViewerUrlRequest {
    url?: string | undefined;
}

export interface MarketingEventWebViewerUrlResponse {
    data?: string | undefined;
}

export interface MarketingEventListDisplayView {
    marketingEventListId?: number;
    count?: number;
    listName?: string | undefined;
    sent?: boolean;
    startDate?: Date;
    endDate?: Date;
    displayStartDate?: Date;
    displayEndDate?: Date;
}

export interface MarketingEventEmailListResponse {
    recordCount?: number;
    emailAllRecords?: MarketingEventListDisplayView[] | undefined;
    data?: MarketingEventListDisplayView[] | undefined;
}

export interface MarketingEventEmailListDetailModel {
    id?: number;
    dateStart?: Date;
    userId?: number;
    dateEnd?: Date;
    marketingEventId?: number;
    sent?: boolean;
    listName?: string | undefined;
    isPaused?: boolean;
}

export interface MarketingEventListModel {
    marketingEventListId?: number;
    marketingEventId?: number;
    listName?: string | undefined;
    dateStart?: string | undefined;
    dateStop?: string | undefined;
    timeStart?: string | undefined;
    timeStop?: string | undefined;
}

export interface AgentNoteListModel {
    id?: number;
    agentId?: number;
    user?: string | undefined;
    userFirstName?: string | undefined;
    userLastName?: string | undefined;
    companyId?: number | undefined;
    companyName?: string | undefined;
    color?: number;
    pinned?: boolean;
    note?: string | undefined;
    userId?: number;
    userTeamId?: number;
    dateTime?: Date;
    private?: boolean;
    agentNoteTypeId?: number;
    noOfDaysSinceNote?: number;
    agentNoteTypeName?: string | undefined;
    title?: string | undefined;
    documentAttachments?: DocumentAttachment[] | undefined;
    correlationId?: string | undefined;
    followupSent?: boolean;
    enableFollowup?: boolean;
    createdByAskIntegrity?: boolean;
}

export interface NoteSearchResponse {
    recordCount?: number;
    emailAllRecords?: AgentNoteListModel[] | undefined;
    data?: AgentNoteListModel[] | undefined;
}

export interface NoteModel {
    id?: number;
    companyId?: number | undefined;
    payoutLevelId?: number | undefined;
    hierarchyPremierId?: number | undefined;
    makeAgentLead?: boolean;
    dateTime?: Date;
    leadId?: number | undefined;
    agentNoteTypeId?: number;
    private?: boolean;
    pinned?: boolean;
    note?: string | undefined;
    marketingEventId?: number;
    contactOptionsDoNotCall?: boolean;
    contactOptionsDoNotEmail?: boolean;
    contactOptionsDoNotMarket?: boolean;
    defaultContactOptionsDoNotCall?: boolean;
    defaultContactOptionsDoNotEmail?: boolean;
    defaultContactOptionsDoNotMarket?: boolean;
    transferFromOtherFmo?: boolean;
    fromSupplyOrder?: boolean;
    saleTypeId?: number | undefined;
    title?: string | undefined;
    documentAttachmentList?: DocumentAttachment[] | undefined;
}

export interface NoteDetailModel {
    id?: number;
    agentId?: number;
    userId?: number;
    userTeamId?: number;
    companyId?: number;
    payoutLevelId?: number | undefined;
    hierarchyPremierId?: number | undefined;
    agentNoteTypeId?: number;
    private?: boolean;
    note?: string | undefined;
    pinned?: boolean;
    contactOptionsDoNotCall?: boolean;
    contactOptionsDoNotEmail?: boolean;
    contactOptionsDoNotMarket?: boolean;
    defaultContactOptionsDoNotCall?: boolean;
    defaultContactOptionsDoNotEmail?: boolean;
    defaultContactOptionsDoNotMarket?: boolean;
    transferFromOtherFmo?: boolean;
    agentNoteTypes?: ListItem[] | undefined;
    markertingLevel?: ListItem[] | undefined;
    companies?: ListItem[] | undefined;
    users?: ListItem[] | undefined;
    saleType?: ListItem[] | undefined;
    isAgency?: number;
    remoteAgency?: boolean;
    saleTypeId?: number | undefined;
    title?: string | undefined;
    documentAttachmentList?: DocumentAttachment[] | undefined;
}

export interface NotePayoutLevelDetailModel {
    payoutLevel?: ListItem[] | undefined;
}

export interface NoteScreenLookupResponse {
    noteTypes?: ListItem[] | undefined;
    users?: ListItem[] | undefined;
}

export interface PayeeListModel {
    id?: number;
    payeeAgentId?: number;
    payeeAgentName?: string | undefined;
    isPayeeHold?: boolean | undefined;
}

export interface PayeeSearchResponse {
    recordCount?: number;
    emailAllRecords?: PayeeListModel[] | undefined;
    data?: PayeeListModel[] | undefined;
}

export interface CreatePayeeModel {
    id?: number;
    agentId?: number;
    payeeId?: number;
}

export interface PrincipalResponseModel {
    id?: number;
    principalAgentId?: number;
    prinicipalAgentName?: string | undefined;
}

export interface PrincipalSearchResponse {
    recordCount?: number;
    emailAllRecords?: PrincipalResponseModel[] | undefined;
    data?: PrincipalResponseModel[] | undefined;
}

export interface PrincipalModelList {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    nickname?: string | undefined;
}

export interface PrincipalAgentSearchResponseModel {
    principalModelLists?: PrincipalModelList[] | undefined;
}

export interface PayingLegalEntityModel {
    id?: number;
    businessUnitCode?: string | undefined;
    businessUnitShortName?: string | undefined;
    businessUnitName?: string | undefined;
    legalEntityCode?: string | undefined;
    legalName?: string | undefined;
}

export interface SearchPayingLegalEntityResponseModel {
    payingLegalEntities?: PayingLegalEntityModel[] | undefined;
}

export interface AgentLegalEntityStatusModel {
    agentId?: number;
    isIntegrityOwnedLegalEntity?: boolean;
    legalEntityId?: number | undefined;
    legalEntityBUName?: string | undefined;
}

export interface PrinicpalAgentsModel {
    id?: number;
    principalAgentName?: string | undefined;
}

export interface PrinicpalAgentsResponse {
    recordCount?: number;
    emailAllRecords?: PrinicpalAgentsModel[] | undefined;
    data?: PrinicpalAgentsModel[] | undefined;
}

export interface PrincipalAgentRequest {
    contractId?: number;
    principalAgentId?: number;
}

export enum EOType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum FileType {
    _0 = 0,
    _1 = 1,
}

export enum PrincipalAgentStatusType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export interface AgentListRequest {
    agencyId?: number;
    marketerIds?: number[] | undefined;
    eoType?: EOType;
    leadSourceIds?: number[] | undefined;
    agentStatusIds?: number[] | undefined;
    agentGroupIds?: number[] | undefined;
    fileType?: FileType;
    counties?: string[] | undefined;
    principalAgentStatusType?: PrincipalAgentStatusType;
    agentImmediateUplineId?: number;
}

export interface ContractedAgentListRequest {
    marketerIds?: number[] | undefined;
    uplineId?: number;
    licenseStatusId?: number;
    companyGroupId?: number;
    companyId?: number;
    homeStates?: string[] | undefined;
    licenseStates?: number[] | undefined;
    leadSource?: number;
    agentStatusId?: number;
    fileType?: FileType;
}

export interface AgentWithoutNotesRequest {
    marketerIds?: number[] | undefined;
    userId?: number;
    agentStatusId?: number;
    notesInXDays?: number;
    fileType?: FileType;
}

export interface ProductionRequest {
    agentId?: number;
    productId?: number;
    uplineId?: number;
    marketerIds?: number[] | undefined;
    companyId?: number;
    locationAgentId?: number;
    startDate?: Date;
    stopDate?: Date;
    policyStatuses?: number[] | undefined;
    whichDate?: string | undefined;
    leadSource?: number;
    customerState?: number;
    licenseStates?: number[] | undefined;
    homeStates?: string[] | undefined;
    categories?: number[] | undefined;
    subCategories?: number[] | undefined;
    agentGroups?: number[] | undefined;
    fileType?: FileType;
    hideOverrides?: boolean;
}

export interface ProductionSummaryRequest {
    agentId?: number;
    productId?: number;
    uplineId?: number;
    marketerIds?: number[] | undefined;
    companyId?: number;
    startDate?: Date;
    stopDate?: Date;
    policyStatuses?: number[] | undefined;
    whichDate?: string | undefined;
    leadSource?: number;
    customerState?: number;
    licenseStates?: number[] | undefined;
    homeStates?: string[] | undefined;
    categories?: number[] | undefined;
    subCategories?: number[] | undefined;
    fileType?: FileType;
}

export interface MarketerProductionRequest {
    whichDate?: string | undefined;
    startDate?: Date;
    stopDate?: Date;
    uplineId?: number;
    marketerIds?: number[] | undefined;
    companyId?: number;
    agentId?: number;
    productId?: number;
    locationId?: number;
    policyStatuses?: number[] | undefined;
    customerState?: number;
    leadSource?: number;
    categories?: number[] | undefined;
    subCategories?: number[] | undefined;
    homeStates?: string[] | undefined;
    licenseStates?: number[] | undefined;
    hideOverrides?: boolean;
    fileType?: FileType;
}

export interface DemographyAndContactsRequest {
    agentId?: number;
    agentStatusIds?: number[] | undefined;
    marketerIds?: number[] | undefined;
    addressTypeIds?: string[] | undefined;
    contactTypeIds?: number[] | undefined;
    smsEnabled?: string | undefined;
    counties?: string[] | undefined;
    fileType?: FileType;
}

export interface AgentStateLicenseRequest {
    agentOrAgencyId?: number;
    stateLicenseIds?: number[] | undefined;
    startDate?: Date;
    endDate?: Date;
    lineOfAuthorityId?: number[] | undefined;
    issueDate?: Date | undefined;
    expirationDate?: Date | undefined;
    stateLicenseStatusId?: string | undefined;
    fileType?: FileType;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}